import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { checkIsLoading, checkIsLoadingDone, checkIsLoadingError } from 'common/utils/checkLoading';

import { CARS_STATE } from '../../constants';

const useCarEBoxDashboardDataLoadingStatus = () => {
  const carEBoxDashboardDataLoadingStatus = useSelector(
    (state: RootState) => state[CARS_STATE].eBoxDashboardData.loadingStatus
  );
  return carEBoxDashboardDataLoadingStatus;
};

export const useIsCarEBoxDashboardDataLoading = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxDashboardDataLoadingStatus();
  return checkIsLoading(carEBoxLocationsLoadingStatus);
};

export const useIsCarEBoxDashboardDataDone = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxDashboardDataLoadingStatus();
  return checkIsLoadingDone(carEBoxLocationsLoadingStatus);
};

export const useIsCarEBoxDashboardDataReject = () => {
  const carEBoxLocationsLoadingStatus = useCarEBoxDashboardDataLoadingStatus();
  return checkIsLoadingError(carEBoxLocationsLoadingStatus);
};

export const useCarEBoxDashboardData = () => {
  const carEBoxLocations = useSelector((state: RootState) => state[CARS_STATE].eBoxDashboardData.data);
  return carEBoxLocations;
};

export const useCarEBoxDashboardDataByObuNumber = (obuNumber: string) => {
  const carEBoxDashboardData = useCarEBoxDashboardData();

  return useMemo(() => (carEBoxDashboardData || []).find(item => item.obuNumber === obuNumber), [carEBoxDashboardData, obuNumber]);
};
